<template>
  <div class="air-icon">
    air icon
  </div>
</template>

<script>
export default {
  name: 'air-icon'
}
</script>
